<template>
  <transition @before-enter="_beforeEnter" @enter="_enter" @before-leave="_beforeLeave" @leave="_leave">
    <div class="bootstrap-modal" tabindex="-1" role="dialog" @click.stop="_backdropClick" :ref="id" v-show="showing">
      <div
        :class="{
          'bootstrap-modal-lg': large,
          'bootstrap-modal-md': medium,
          'bootstrap-modal-sm': small,
          'bootstrap-modal-dialog': normal == 1,
          'bootstrap-modal-dialog2': normal == 2,
          'bootstrap-modal-dialog3': normal == 3
        }"
        role="document"
      >
        <div class="bootstrap-modal-content">
          <div class="d-flex bootstrap-modal-header items-start" v-if="title">
            <h4 class="bootstrap-modal-title mr-3">
              <slot name="title">{{ this.title }}</slot>
            </h4>
            <div class="ml-auto">
              <span class="close" style="color:#0c0c0c" aria-hidden="true" v-show="showClose" @click.stop="hide">&times;</span>
              <!--<v-icon style="color:#0c0c0c" v-show="showClose" @click.stop="hide">clear</v-icon>-->
            </div>
          </div>
          <div class="bootstrap-modal-header2 row justify-end items-end" v-if="close">
            <div>
              <v-icon style="color:#0c0c0c;z-index: 100;" v-show="showClose" @click.stop="hide">clear</v-icon>
            </div>
          </div>
          <div class="bootstrap-modal-body">
            <slot></slot>
          </div>
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import tool from '@/common/js/tool';
let transitionClass = 'transition-am';
export default {
  name: 'BootstrapModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // modal标题
    title: {
      type: String,
      default: ''
    },
    // 点击灰色背景是否关闭弹窗
    backdrop: {
      type: Boolean,
      default: true
    },
    // 是否使用大的modal
    large: {
      type: Boolean,
      default: false
    },
    medium: {
      type: Boolean,
      default: false
    },
    // 是否使用小的modal
    small: {
      type: Boolean,
      default: false
    },
    normal: {
      type: Number,
      default: 1
    },
    close: {
      type: Boolean,
      default: false
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showing: false,
      id:
        'bootstrap_modal' +
        new Date().getTime() +
        '_' +
        Math.random()
          .toString(32)
          .substr(2),
      showCount: 0
    };
  },
  methods: {
    show() {
      this.showing = true;
      if (this.value === false) {
        this.$emit('input', true);
      }
      tool.addClass(document.body, 'modal-open');
      if (window.innerWidth < 992) {
        document.body.style.height = window.innerHeight + 'px';
      }
      this.showCount++;
      if (this.showCount === 1) {
        this.$emit('firstShow');
      }
      this.$emit('onshow');
    },
    hide() {
      this.showing = false;
      if (this.value === true) {
        this.$emit('input', false);
      }
      tool.removeClass(document.body, 'modal-open');
      if (window.innerWidth < 992) {
        document.body.style.height = '';
        document.body.style.overflow = '';
      }
      this.$emit('onhide');
    },
    _backdropClick(e) {
      let bootstrapModal = this.$refs[this.id];
      let target = e.target;

      if (tool.elementContains(bootstrapModal, target)) {
        return;
      }
      if (this.backdrop) {
        this.hide();
      }
    },
    _beforeEnter(el) {
      tool.addClass(el, transitionClass);
      el.style.opacity = 0;
    },
    _enter(el, done) {
      let fn = () => {
        tool.removeClass(el, transitionClass);
        tool.off(el, 'transitionend', fn);
        done();
      };
      tool.on(el, 'transitionend', fn);

      let timer = setTimeout(() => {
        el.style.opacity = 1;

        let modalDialog = el.children[0];
        let offsetHeight = modalDialog.offsetHeight;

        // if (!this.small && window.innerWidth > 991) {
        //   // pc端弹窗垂直居中，移动端不进行垂直居中
        //   let wh = window.innerHeight;
        //   if ((wh - offsetHeight) / 2 > 30) {
        //     modalDialog.style.marginTop = ((wh - offsetHeight) / 2) + 'px';
        //   }
        // } else {
        //   // let mt = modalDialog.style.marginTop;
        //   // if ((mt + '').length > 0) {
        //   //   modalDialog.style.marginTop = '';
        //   // }
        //   let wh = window.innerHeight;
        //   if ((wh - offsetHeight) / 2 > 30) {
        //     modalDialog.style.marginTop = ((wh - offsetHeight) / 2) + 'px';
        //   }
        // }
        modalDialog = null;
        offsetHeight = null;
        clearTimeout(timer);
      }, 10);
    },
    _beforeLeave(el) {
      el.style.opacity = 1;
      tool.addClass(el, transitionClass);
    },
    _leave(el, done) {
      let fn = () => {
        tool.removeClass(el, transitionClass);
        tool.off(el, 'transitionend', fn);
        done();
      };
      tool.on(el, 'transitionend', fn);

      let timer = setTimeout(() => {
        el.style.opacity = 0;
        clearTimeout(timer);
      }, 10);
    }
  },
  watch: {
    value(newval) {
      if (newval) {
        this.show();
      } else {
        this.hide();
      }
    }
  },
  beforeDestroy() {
    try {
      let flag = tool.elementContains(document.body, this.$el);
      if (flag) {
        document.body.removeChild(this.$el);
      }
    } catch (e) {
      console.error(e);
    }
    tool.removeClass(document.body, 'modal-open');
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.$nextTick(() => {
      this.value && this.show();
    });
  }
};
</script>

<style lang="stylus" scoped>
@import './bootstrap-modal.styl';
</style>
